// import { IResourceComponentsProps } from "@refinedev/core";
// import { MuiCreateInferencer } from "@refinedev/inferencer/mui";

// export const CasseCreate: React.FC<IResourceComponentsProps> = () => {
//     return (
//         <MuiCreateInferencer
//             fieldTransformer={(field: any) => {
//                 if (["locale", "updatedAt", "publishedAt"].includes(field.key)) {
//                     return false;
//                 }

//                 return field;
//             }}
//         />
//     );
// };

import {
  Box,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useGetIdentity, useTranslation } from "@refinedev/core";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { Controller } from "react-hook-form";
import { useQuery } from "react-query";
import { getContainers } from "services/container";

export const CasseCreate = () => {
  const { translate } = useTranslation();

  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    control,
    formState: { errors },
    watch,
  } = useForm();

  const { data: user } = useGetIdentity<{
    name: string;
    avatar: any;
    id: any;
  }>();

  const userId = user && user.id;
  const { data: dataContainers } = useQuery({
    queryKey: "containers-data",
    queryFn: getContainers(false),
  });

  const data = watch();

  return (
    <Create
      isLoading={formLoading}
      saveButtonProps={data.container && saveButtonProps}
    >
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <FormControl sx={{ mt: -1, display: "none" }}>
          <TextField
            type="hidden"
            {...register("user", {
              required: translate("this-field-is-required"),
            })}
            error={!!(errors as any)?.user}
            helperText={(errors as any)?.user?.message}
            margin="normal"
            value={userId}
            InputLabelProps={{ shrink: true }}
            name="user"
          />
        </FormControl>
        <TextField
          {...register("quantity", {
            required: translate("this-field-is-required"),
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.quantity}
          helperText={(errors as any)?.quantity?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Quantity"
          name="quantity"
        />
        {/*
                    DatePicker component is not included in "@refinedev/mui" package.
                    To use a <DatePicker> component, you can follow the official documentation for Material UI.

                    Docs: https://mui.com/x/react-date-pickers/date-picker/#basic-usage
                */}
        {dataContainers && (
          <Controller
            control={control}
            name="container"
            rules={{ required: translate("this-field-is-required") }}
            // eslint-disable-next-line
            defaultValue={null as any}
            render={({ field }) => (
              <FormControl sx={{ mb: 1 }}>
                <FormLabel>Container</FormLabel>
                <Select {...field} name="container" label="Container">
                  <MenuItem>Select Container</MenuItem>
                  {(dataContainers || []).map((item: any, index: number) => (
                    <MenuItem key={index} value={item.id}>
                      [{item?.type}] {item?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          />
        )}
      </Box>
    </Create>
  );
};
